const identity = (v: any) => v;

const isObject = (v: any) => typeof v === 'object' && !!v;

const isNil = (v: any) => v === undefined || v === null;

function omitNil(obj: any) {
  if (isObject(obj)) {
    const transformed = {};
    for (const key in obj) {
      if (!isNil(obj[key])) {
        transformed[key] = obj[key];
      }
    }
    return transformed;
  }
  return obj;
}

function parseLabel(obj: any) {
  if (obj && !isNil(obj.label)) {
    return {
      ...obj,
      label: String(obj.label),
    };
  }
  return obj;
}

function parseValue(obj: any) {
  if (obj && obj.value !== undefined && obj.value !== null) {
    const value = parseFloat(obj.value);
    if (!isNaN(value)) {
      return {
        ...obj,
        value,
      };
    }
    return {
      ...obj,
      value: null,
    };
  }
  return obj;
}

function mapKeys(srcObj: object, keyMap: object, preserveDefaults = false) {
  if (srcObj) {
    return Object.keys(srcObj).reduce((memo: object, srcKey: string) => {
      const tgtKey = keyMap[srcKey];
      const tgtObject = { ...memo };
      if (tgtKey) {
        tgtObject[tgtKey] = srcObj[srcKey];
      } else if (preserveDefaults) {
        tgtObject[srcKey] = srcObj[srcKey];
      }
      return tgtObject;
    }, {});
  }
  return {};
}

function splitOrArray(str: string | string[], delimiter: string) {
  if (str && !Array.isArray(str) && typeof str === 'string') {
    return str.split(delimiter);
  }
  return str || [];
}

export {
  identity,
  isObject,
  isNil,
  omitNil,
  parseLabel,
  parseValue,
  mapKeys,
  splitOrArray,
};
